import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-4 mb-10" }
const _hoisted_2 = { class: "flex justify-between items-center" }
const _hoisted_3 = { class: "text-lg font-bold" }
const _hoisted_4 = { class: "flex gap-3" }
const _hoisted_5 = {
  key: 0,
  ref: "questionOptions",
  class: "bg-white w-72 py-2 shadow-md rounded-md absolute mt-10 right-10"
}
const _hoisted_6 = { class: "text-[14px] ml-1" }
const _hoisted_7 = { class: "text-[14px] ml-1" }
const _hoisted_8 = { class: "flex flex-col md:flex-row justify-center md:justify-between items-center gap-3 bg-gray-200 font-bold p-4 rounded-md shadow-md" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = {
  key: 0,
  class: "bg-white rounded-lg border-b-4 border-h-primary-500 shadow-sm p-5"
}
const _hoisted_11 = {
  key: 0,
  class: "bg-h-warning-100 text-h-warning-700 w-fit px-2 py-1 rounded-sm shadow-sm text-sm mb-3"
}
const _hoisted_12 = { class: "flex items-center justify-between" }
const _hoisted_13 = { class: "font-bold text-lg break-words w-full" }
const _hoisted_14 = { class: "text-gray-500 my-3 flex items-start gap-3" }
const _hoisted_15 = { class: "font-bold" }
const _hoisted_16 = { class: "break-words max-w-full" }
const _hoisted_17 = {
  key: 1,
  class: "flex justify-end items-center gap-3"
}
const _hoisted_18 = {
  key: 0,
  class: "py-10"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_Button = _resolveComponent("Button")!
  const _component_ImportCSV = _resolveComponent("ImportCSV")!
  const _component_EmptyData = _resolveComponent("EmptyData")!
  const _component_Loader = _resolveComponent("Loader")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("main", _hoisted_1, [
      _createElementVNode("section", _hoisted_2, [
        _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t("quiz.teacher.questions")), 1),
        _createElementVNode("div", _hoisted_4, [
          (_ctx.showQuestionOptions)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                (_ctx.role === 'TEACHER')
                  ? (_openBlock(), _createBlock(_component_Button, {
                      key: 0,
                      id: "btn-register-questions",
                      class: "btn-simple p-button-sm",
                      disabled: !_ctx.quizId,
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goToQuestion()))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, { name: "md-add" }),
                        _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t("labels.generic", {
                  pt: "Cadastrar questões",
                  en: "Create questions",
                })), 1)
                      ]),
                      _: 1
                    }, 8, ["disabled"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_ImportCSV, {
                  onOnUpload: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onUpload($event))),
                  onOnDownload: _cache[2] || (_cache[2] = ($event: any) => (_ctx.downloadCSV())),
                  onOnClose: _ctx.onClose,
                  data: _ctx.importData,
                  openModal: _ctx.displayModal,
                  btnStyle: "btn-simple w-full",
                  btnIcon: "md-uploadfile-round",
                  buttons: {
              first: _ctx.$t('labels.generic', {
                pt: 'Importar questões',
                en: 'Import questions',
              }),
              second: _ctx.$t('labels.generic', {
                pt: 'Importar novo documento',
                en: 'Import new document',
              }),
            }
                }, null, 8, ["onOnClose", "data", "openModal", "buttons"]),
                _createVNode(_component_Button, {
                  id: "btn-download-csv",
                  class: "btn-simple",
                  onClick: _ctx.downloadCSVTemplate
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, { name: "md-insertdrivefile-round" }),
                    _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t("labels.generic", {
                  pt: "Baixar modelo de importação",
                  en: "Download import model",
                })), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ], 512))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("section", _hoisted_8, [
        _createElementVNode("p", null, _toDisplayString(_ctx.$t("quiz.teacher.list")), 1),
        (!_ctx.loader)
          ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(_ctx.questions?.length) + " " + _toDisplayString(_ctx.$t("labels.generic", { pt: "Questões", en: "Questions" })), 1))
          : _createCommentVNode("", true)
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.questionsLocal, (question, q) => {
        return (_openBlock(), _createElementBlock("section", { key: q }, [
          (!_ctx.loader)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                (question.openQuestion)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_ctx.$t("labels.generic", { pt: "Questão aberta", en: "Open question" })), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("p", _hoisted_13, _toDisplayString(question.prompt), 1)
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(question.items, (item, i) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: i,
                    class: "mb-5"
                  }, [
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("span", _hoisted_15, [
                        _createVNode(_component_v_icon, {
                          name: `${
                  item.id === question.correctItem?.id
                    ? 'hi-solid-check'
                    : 'hi-x'
                }`,
                          class: _normalizeClass(`${
                  item.id === question.correctItem?.id
                    ? 'text-h-success-400'
                    : 'text-h-error-400'
                }`)
                        }, null, 8, ["name", "class"])
                      ]),
                      _createElementVNode("p", _hoisted_16, _toDisplayString(item.answerText), 1)
                    ])
                  ]))
                }), 128)),
                (_ctx.role === 'TEACHER')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                      _createVNode(_component_Button, {
                        id: `btn-edit-question-${q}`,
                        class: "btn-simple p-button-sm",
                        icon: "pi pi-pencil",
                        label: _ctx.$t('labels.edit'),
                        onClick: ($event: any) => (_ctx.goToQuestion(question.id))
                      }, null, 8, ["id", "label", "onClick"]),
                      _createVNode(_component_Button, {
                        id: `btn-delete-question-${q}`,
                        class: "btn-delete p-button-sm",
                        icon: "pi pi-trash",
                        label: _ctx.$t('labels.delete'),
                        loading: _ctx.loadBtn[q],
                        onClick: ($event: any) => (_ctx.deleteQuestion(question.id, q))
                      }, null, 8, ["id", "label", "loading", "onClick"])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]))
      }), 128)),
      (!_ctx.questions || (_ctx.questions.length === 0 && !_ctx.loader))
        ? (_openBlock(), _createElementBlock("section", _hoisted_18, [
            _createVNode(_component_EmptyData, {
              data: !_ctx.questions || _ctx.questions.length === 0,
              label: _ctx.emptyState.description,
              image: _ctx.emptyState.image,
              imgSize: "h-24"
            }, null, 8, ["data", "label", "image"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_Loader, {
      loader: _ctx.loader,
      loaderSize: "h-48"
    }, null, 8, ["loader"])
  ], 64))
}